<header class="page-head">
  <div class="page-head__identity">
    <span class="page-head__icon"><i class="fa fa-user"></i></span>
    <div>
      <h1 class="page-head__title">{{ title }}</h1>
    </div>
  </div>
  <div class="page-head__actions">
    <button
      *ngIf="userId && canSeeEditLogs"
      type="button"
      class="sf-btn sf-btn--primary"
      (click)="editLogs.open(userId, userForm.get('name').value)"
      data-testid="btn-user-edit-logs"
    >
      <i class="fa fa-eye"></i> Histórico de edições
    </button>
    <a *ngIf="userId" [routerLink]="['/users/new']" class="sf-btn sf-btn--secondary">
      <i class="fa fa-plus-circle"></i> Novo Usuário
    </a>
  </div>
</header>

<app-user-edit-logs #editLogs></app-user-edit-logs>

<form [formGroup]="userForm" (submit)="save()" autocomplete="off">
  <section class="sf-card">
    <div class="field-grid">
      <div class="field field--wide">
        <label for="name">Nome</label>
        <input id="name" type="text" class="form-control" formControlName="name" #nameInput data-testid="input-user-name"/>
        <small *ngIf="userForm.get('name').errors?.required" class="field-error" data-testid="name-required-error">
          Preencha o nome do usuário
        </small>
        <small *ngIf="userForm.get('name').errors?.minlength" class="field-error" data-testid="name-small-error">
          O nome do usuário deve ter pelo menos 5 caracteres
        </small>
      </div>

      <div class="field field--wide">
        <label for="document">CPF</label>
        <input id="document" type="text" class="form-control" formControlName="document" data-testid="input-user-document" (input)="formatCpf($event)" #documentInput />
        <small *ngIf="userForm.get('document').errors?.required" class="field-error">
          Preencha o CPF
        </small>
        <small *ngIf="!userForm.get('document').errors?.required && userForm.get('document').errors?.cpfInvalid" class="field-error">
          O CPF informado é inválido.
        </small>
      </div>

      <div class="field">
        <label for="email">E-mail</label>
        <input id="email" type="email" class="form-control" formControlName="email" data-testid="input-user-email" autocomplete="nope" />
        <small *ngIf="userForm.get('email').errors?.required" class="field-error" data-testid="email-required-error">
          Preencha o e-mail
        </small>
        <small *ngIf="userForm.get('email').errors?.email" class="field-error" data-testid="email-invalid-error">
          E-mail inválido
        </small>
      </div>

      <div class="field">
        <label for="pix_key">Chave Pix:</label>
        <input id="pix_key" type="text" class="form-control" formControlName="pix_key" data-testid="input-user-pix-type"/>
      </div>

      <div class="field">
        <label for="phone">Telefone</label>
        <input appPhone id="phone" type="text" class="form-control" formControlName="phone" data-testid="input-user-phone"/>
        <small *ngIf="userForm.get('phone').errors?.required" class="field-error" data-testid="phone-required-error">
          Preencha o telefone
        </small>
      </div>

      <div class="field">
        <label for="profile" data-testid="label-perfil-for-get-errors">Perfil</label>
        <div *ngIf="profiles$ | async as profiles; else loading">
          <select class="form-select" id="profile" formControlName="profile_id" data-testid="input-user-profile-type">
            <option *ngFor="let profile of profiles" [value]="profile.id">{{ profile.name }}</option>
          </select>
        </div>
        <small *ngIf="userForm.get('profile_id').errors?.required" class="field-error" data-testid="client-type-required-error">
          Preencha o Perfil
        </small>
      </div>

      <div class="field" *ngIf="showCommission">
        <label for="commission">Comissão (%)</label>
        <input type="number" class="form-control" name="commission" id="commission" formControlName="commission">
      </div>

      <div class="field">
        <label for="operation_type">Modelo de negócio</label>
        <select class="form-select" id="operation_type" formControlName="operation_type">
          <option *ngFor="let operationType of operationTypes" [value]="operationType.value">{{ operationType.label }}</option>
        </select>
        <small *ngIf="userForm.get('operation_type').errors?.required" class="field-error">
          Preencha com o modelo de negócio
        </small>
      </div>

      <div class="field">
        <label for="unit_cost_sms">Custo Unitário de Envio</label>
        <input id="unit_cost_sms" type="number" class="form-control" formControlName="unit_cost_sms"
               step="0.001" min="0" placeholder="0.000" />
      </div>

      <div class="field">
        <label for="password">Nova senha</label>
        <input type="password" id="password" class="form-control" formControlName="password"
               [readonly]="generatePassword" autocomplete="new-password"
               data-testid="input-new-password" />
        <ng-container *ngIf="userForm.get('password').touched">
          <small class="field-error" *ngIf="userForm.get('password').errors?.required">
            Nova senha é obrigatória
          </small>
          <small class="field-error" *ngIf="userForm.get('password').errors?.minlength">
            A nova senha deve ter no mínimo 8 caracteres
          </small>
        </ng-container>
      </div>

      <div class="field">
        <label for="password_confirmation">Confirmação da nova senha</label>
        <input type="password" id="password_confirmation" class="form-control" formControlName="password_confirmation"
               data-testid="input-new-password-confirm"
               [readonly]="generatePassword" />
        <ng-container *ngIf="userForm.get('password_confirmation').touched">
          <small class="field-error" *ngIf="
              userForm.get('password_confirmation').errors?.required
            " data-testid="new-pass-required">
            Confirmação da nova senha é obrigatória
          </small>
          <small class="field-error" *ngIf="
              userForm.get('password_confirmation').errors?.minlength
            ">
            A nova senha deve ter no mínimo 8 caracteres
          </small>
          <small class="field-error" *ngIf="
              userForm.get('password_confirmation').errors
                ?.different
            "
                 data-testid="new-pass-different"
          >
            Nova senha não foi confirmada corretamente
          </small>
        </ng-container>
      </div>
    </div>
  </section>

  <section class="sf-card">
    <h3 class="section-title">Configurações gerais:</h3>

    <div class="switch-grid">
      <app-switcher look="v2" id="generate_password" label="Gerar Senha?" display="block" [(checked)]="generatePassword"
                    (change)="toggleGeneratePassword()" />

      <div data-testid="switch-user-active">
        <app-switcher look="v2" id="user_active" label="Usuário ativo?" display="block" [(checked)]="active" />
      </div>

      <app-switcher look="v2" id="sms_token_validated" label="Remover token?" display="block" [(checked)]="tokenVerifyEnabled" />

      <!-- CU-86ak84mj6 — só desliga: ativar depende do autenticador do usuário -->
      <div class="switch-wide" *ngIf="showTwoFactorToggle" data-testid="switch-user-two-factor">
        <app-switcher
          look="v2"
          #twoFactorSwitcher
          id="two_factor_enabled"
          label="Verificação em duas etapas"
          display="block"
          [checked]="twoFactorEnabled"
          (checkedChange)="onTwoFactorToggle($event)"
        ></app-switcher>

        <small class="d-block mt-1 two-factor-note">
          <ng-container *ngIf="twoFactorWasEnabled">
            Ativa. Gere uma chave nova se o usuário perdeu o aplicativo, ou
            desligue para liberar o acesso sem segundo fator.
          </ng-container>
          <ng-container *ngIf="!twoFactorWasEnabled">
            Ligue para gerar a chave do autenticador e repassá-la ao usuário.
            As sessões abertas dele serão encerradas.
          </ng-container>
        </small>

        <a href="javascript:void(0)" class="d-inline-block mt-2"
           *ngIf="twoFactorWasEnabled && !twoFactorProvision && !twoFactorConfirmingDisable && !twoFactorConfirmingReset"
           (click)="twoFactorConfirmingReset = true" data-testid="link-2fa-new-key">
          Gerar chave nova
        </a>

        <!-- Confirmação de desligar: invalida o aplicativo do usuário. -->
        <div class="alert alert-warning mt-3" *ngIf="twoFactorConfirmingDisable"
             data-testid="confirm-2fa-disable">
          <p class="mb-2">
            <strong>Desativar a verificação em duas etapas deste usuário?</strong>
          </p>
          <p class="mb-3">
            A chave que ele tem no aplicativo autenticador deixa de valer, e as
            sessões abertas serão encerradas. Se você ativar de novo depois, a
            chave será outra e ele terá que cadastrá-la do zero.
          </p>
          <button type="button" class="sf-btn sf-btn--danger sf-btn--sm" [disabled]="twoFactorBusy"
            (click)="confirmDisableTwoFactor()" data-testid="btn-2fa-disable-confirm">
            Desativar
          </button>
          <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm" (click)="cancelTwoFactorConfirm()">
            Cancelar
          </button>
        </div>

        <!-- Confirmação de gerar chave nova para quem já tem. -->
        <div class="alert alert-warning mt-3" *ngIf="twoFactorConfirmingReset"
             data-testid="confirm-2fa-reset">
          <p class="mb-2">
            <strong>Gerar uma chave nova para este usuário?</strong>
          </p>
          <p class="mb-3">
            A chave atual dele deixa de valer imediatamente e as sessões abertas
            serão encerradas. Ele precisará cadastrar a chave nova no aplicativo
            para conseguir entrar.
          </p>
          <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" [disabled]="twoFactorBusy"
            (click)="provisionTwoFactor()" data-testid="btn-2fa-reset-confirm">
            Gerar chave nova
          </button>
          <button type="button" class="sf-btn sf-btn--ghost sf-btn--sm" (click)="cancelTwoFactorConfirm()">
            Cancelar
          </button>
        </div>

        <!-- A chave, uma única vez. -->
        <div class="sf-card two-factor-provision mt-3" *ngIf="twoFactorProvision"
             data-testid="panel-2fa-provision">
          <p class="mb-3">
            <strong>Envie estes dados ao usuário.</strong> Eles não aparecem
            de novo — fechando este painel, a única saída é gerar outra chave.
          </p>

          <label class="d-block">Chave do autenticador</label>
          <div class="copy-field mb-3">
            <code class="wrap" data-testid="text-2fa-secret">{{ twoFactorProvision.secret }}</code>
            <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm"
              (click)="copyTwoFactorSecret()" data-testid="btn-copy-2fa-secret">
              Copiar
            </button>
          </div>

          <label class="d-block">Códigos de recuperação</label>
          <div class="copy-field mb-3">
            <code class="wrap" data-testid="text-2fa-recovery">{{
              twoFactorProvision.recovery_codes.join('  ')
            }}</code>
            <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm"
              (click)="copyTwoFactorRecoveryCodes()" data-testid="btn-copy-2fa-recovery">
              Copiar
            </button>
          </div>

          <img *ngIf="twoFactorProvision.qr_code" [src]="twoFactorProvision.qr_code"
            alt="QR Code do autenticador" class="two-factor-qr mb-3" />

          <button type="button" class="sf-btn sf-btn--secondary sf-btn--sm"
            (click)="dismissTwoFactorProvision()" data-testid="btn-2fa-provision-done">
            Já enviei, fechar
          </button>
        </div>
      </div>

      <app-switcher look="v2" id="content_tag_enabled" label="Informar conteúdo de mensagem por webhook?" display="block" [(checked)]="contentTagEnabled" />
      <app-switcher look="v2" id="fake_request" label="Fake Request?" display="block" [(checked)]="fakeRequest" />
      <app-switcher look="v2" id="leads_export" label="Exportar Leads" display="block" [(checked)]="exportLeads" (checkedChange)="onSwitchChange($event)"
      ></app-switcher>

      <app-switcher look="v2" id="broadcast_send_interval" label="Forçar intevalo para broadcast" display="block" [(checked)]="broadcastSendInterval" />
      <app-switcher look="v2" id="revision_sms_enabled" label="Revisar SMS?" display="block" [(checked)]="revisionSmsEnabled" />
      <app-switcher look="v2" id="massive_sms_enabled" label="SMS Massivo?" display="block" [(checked)]="massiveSmsEnabled" />

      <app-switcher look="v2" id="credit_payment_enabled" label="Pagamento com Crédito?" display="block"
                    [(checked)]="creditPaymentEnabled" />
      <app-switcher look="v2" id="is_billable" label="Emitir notas?" display="block" [(checked)]="billingEnabled" />

      <div *ngIf="showApiToggle" data-testid="switch-user-api-enabled">
        <app-switcher look="v2" id="api_enabled" label="Habilitar API?" display="block" [(checked)]="partnersAPIEnabled" />
      </div>
      <app-switcher look="v2" id="ai_enabled" label="Habilitar IA?" display="block" [(checked)]="aiEnabled" />
      <div *ngIf="isAdministrator && userId">
        <app-switcher
          look="v2"
          id="can-propose"
          label="Pode propor eventos de integração"
          display="block"
          [checked]="canProposeIntegrations"
          (checkedChange)="toggleProposeIntegrations($event)"
          data-testid="user-edit-can-propose"
        ></app-switcher>
        <small class="field-hint">Quando ativo, o usuário pode cadastrar novos eventos de integração (sujeitos a aprovação).</small>
      </div>
      <div data-testid="switch-user-integration-sms-enabled">
        <!--
          O tooltip não é enfeite: além de liberar a tela, esta flag faz os
          disparos vindos de outra plataforma pularem a fila de revisão. Quem
          liga precisa saber disso na hora de ligar.
        -->
        <app-switcher
          look="v2"
          id="integration_sms_enabled"
          label="SMS via Integração?"
          display="block"
          tooltip="Libera a tela 'SMS via Integração' e dispensa esses disparos da fila de revisão — a plataforma envia um SMS por contato, então a aprovação é esta, feita uma vez. Higienização e blacklist continuam valendo."
          [(checked)]="integrationSmsEnabled"
        />
      </div>

      <div *ngIf="showPostbackTokenToggle" data-testid="switch-user-postback-token-required">
        <app-switcher
          look="v2"
          id="postback_token_required"
          label="Exigir token nos postbacks"
          display="block"
          tooltip="Postbacks e add-lead desta conta que chegarem sem o token da URL passam a ser recusados. Antes de ligar para um cliente antigo, confirme que as integrações e formulários dele já usam as URLs novas do painel."
          [(checked)]="postbackTokenRequired"
        />
      </div>

      <!-- Multiusuários (CU-17tm466h1cm): liberação conta a conta. -->
      <div *ngIf="showMultiuserToggle" data-testid="switch-user-multiuser-enabled">
        <app-switcher
          look="v2"
          id="multiuser_enabled"
          label="Ativar Multiusuários?"
          display="block"
          tooltip="Libera a conta para convidar membros, cada um com login próprio e acesso completo à conta. Desligar não apaga os membros: eles só deixam de entrar até a conta ser liberada de novo."
          [(checked)]="multiuserEnabled"
        />
      </div>

      <!--
        WhatsApp oficial/Meta (CU-17tm466qj38): só o administrador vê e altera. As duas opções
        ao lado só fazem sentido com ele ligado.
      -->
      <ng-container *ngIf="canManageWhatsappAccounts">
        <div data-testid="switch-user-whatsapp-enabled">
          <app-switcher look="v2" id="whatsapp_enabled" label="WhatsApp oficial?" display="block"
                        tooltip="Libera o WhatsApp oficial (Meta): conta Meta, templates, caixa de entrada, a etapa de WhatsApp na automação e o envio."
                        [(checked)]="whatsappEnabled"
          ></app-switcher>
        </div>
        <!-- CU-17tm466tzkz: conta com contrato negociado pode ficar fora do bônus da faixa. -->
        <div *ngIf="showRechargeBonusToggle" data-testid="switch-user-recharge-bonus-enabled">
          <app-switcher
            look="v2"
            id="recharge_bonus_enabled"
            label="Recebe bônus de recarga"
            display="block"
            tooltip="Desligado, a recarga que o próprio cliente faz (Pix/cartão) entra sem o bônus da faixa e a tela de recarga dele não mostra as faixas. Na recarga manual o switch de bônus vem desmarcado, mas você ainda pode forçar."
            [(checked)]="rechargeBonusEnabled"
          />
        </div>
        <!-- N integrações de WhatsApp (CU-17tm466mfzu): liberação aos poucos + teto por cliente. -->
        <div *ngIf="whatsappEnabled" data-testid="switch-user-whatsapp-multi-accounts">
          <app-switcher
            look="v2"
            id="whatsapp_multi_accounts"
            label="Várias integrações de WhatsApp?"
            display="block"
            tooltip="Libera o botão Adicionar em Integrações WhatsApp. Sem isto a conta fica com uma integração (a Principal)."
            [(checked)]="whatsappMultiAccounts"
          />
        </div>
        <div *ngIf="whatsappEnabled && whatsappMultiAccounts" data-testid="input-user-max-whatsapp-accounts">
          <label for="max_whatsapp_accounts">Limite de integrações de WhatsApp</label>
          <input id="max_whatsapp_accounts" type="number" min="1" max="50" class="form-control"
            [(ngModel)]="maxWhatsappAccounts" [ngModelOptions]="{standalone: true}">
        </div>
      </ng-container>
    </div>
  </section>

  <section class="sf-card">
    <h3 class="section-title">Configurações de venda e rastreamento:</h3>

    <div class="switch-grid">
      <app-switcher look="v2" id="analytics_sync" label="Exibir relatório de clicks?" display="block" [(checked)]="analyticsSync" />
      <app-switcher look="v2" id="analytics_sales_sync" label="Ativar relatório de vendas?" display="block" [(checked)]="analyticsSalesSync" (checkedChange)="onFunnelDependencyToggle()" />
      <app-switcher look="v2" id="funnel_report_enabled" label="Ativar relatório de funil?" display="block" [(checked)]="funnelReportEnabled" (checkedChange)="onFunnelReportToggle($event)" />

      <app-switcher look="v2" id="delivery_report_enabled" label="Habilitar relatório de entrega?" display="block" [(checked)]="deliveryReportEnabled" (checkedChange)="onFunnelDependencyToggle()" />
      <app-switcher look="v2" id="show_sales_report" label="Exibir relatório de vendas?" display="block" [(checked)]="showSalesReport" />
      <app-switcher look="v2" id="show_funnel_report" label="Exibir funil para o cliente?" display="block" [(checked)]="showFunnelReport" />

      <app-switcher look="v2" id="disable_utm_source" label="Desativar utm_source SMSFunnel?" display="block" [(checked)]="disableUtmSource" />
    </div>
  </section>

  <section class="sf-card">
    <h3 class="section-title">Configurações de rotas:</h3>

    <div class="field-grid">
      <div class="field">
        <label>Rota Automação</label>
        <input type="text" class="form-control" [matAutocomplete]="autoCompleteAutomationFractionation"
          formControlName="automation_fractionation_route"
          (focus)="updateAutomationFractionationGroupsFilter()"
          (blur)="onAutomationControlBlur()">
        <small *ngIf="userForm.get('automation_fractionation_route')?.errors" class="field-error" data-testid="name-small-error">
          Informe a rota de automação
        </small>
        <mat-autocomplete #autoCompleteAutomationFractionation="matAutocomplete" [displayWith]="displayFractionationGroupFn">
          <mat-option *ngFor="let option of filteredAutomationFractionationGroupsOptions | async" [value]="option">
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="field">
        <label>Rota Broadcast</label>
        <input type="text" class="form-control" [matAutocomplete]="autoCompleteBroadcastFractionation"
          formControlName="broadcast_fractionation_route"
          (focus)="updateBroadcastFractionationGroupsFilter()"
          (blur)="onBroadcastControlBlur()">
        <small *ngIf="userForm.get('broadcast_fractionation_route')?.errors" class="field-error" data-testid="name-small-error">
          Informe a rota de broadcast
        </small>
        <mat-autocomplete #autoCompleteBroadcastFractionation="matAutocomplete" [displayWith]="displayFractionationGroupFn">
          <mat-option *ngFor="let option of filteredBroadcastFractionationGroupsOptions | async" [value]="option">
            {{ option.name }}
          </mat-option>
        </mat-autocomplete>
      </div>

      <div class="field">
        <label for="shortener_id">Encurtador:</label>
        <div *ngIf="shorteners$ | async as shorteners; else loading">
          <select class="form-select" id="shortener_id" formControlName="shortener_id" data-testid="select-shorting">
            <option *ngFor="let shortener of shorteners" [value]="shortener.id">{{ shortener.name }}</option>
          </select>
        </div>
      </div>
    </div>

    <div class="switch-grid">
      <app-switcher look="v2" id="" label="Pix prioritário (OTP)?" display="block" [(checked)]="pixPriority" />
    </div>

    <div class="field field--wide">
      <label for="monitored_numbers">Números monitorados:</label>
      <div class="monitored-input-container-numbers" (click)="tagInput.focus()">
        <!-- Tags displayed inline before the actual input -->
        <ul>
          <li *ngFor="let number of monitoredNumbers.controls; let i = index" class="chip">
            <button type="button" aria-label="Remover número" (click)="removeMonitoredNumber(i); $event.stopPropagation()"><i class="fa fa-times-circle"></i></button>
            {{ number.value }}
          </li>
        </ul>

        <!-- Hidden actual input field where typing occurs -->
        <input #tagInput appPhone type="text" class="form-control form-control-rounded"
           [formControl]="currentMonitoredPhoneControl"
          (keydown.enter)="addMonitoredNumber(); $event.preventDefault()"
          placeholder="Adicionar número monitorado"
          />
      </div>
      <small class="field-hint">Pressione <code>Enter</code> para confirmar a adição</small>
    </div>
  </section>

  <!-- RCS (17tm466frtx): flag, rotas RCS de massa e automação, e por onde o RCS sai. -->
  <app-user-rcs-settings [form]="userForm" [userId]="userId" [canPreview]="canSeeEditLogs"></app-user-rcs-settings>

  <div class="form-actions">
    <button class="sf-btn sf-btn--primary" [appLoadingButton]="isSaving"
      [disabled]="userForm.invalid" data-testid="btn-register-new-user">
      Salvar
    </button>

    <a [routerLink]="['/dashboard']" class="sf-btn sf-btn--secondary">
      {{ userId ? 'Voltar' : 'Cancelar' }}
    </a>
  </div>
</form>

<ng-template #loading>
  <span class="form-control">
    Carregando...
  </span>
</ng-template>

<app-clients *ngIf="showCommission" [user]="user"></app-clients>
